const baseUrl = import.meta.env.VITE_ENVIA_CLIENTS_URL || process.env.VITE_ENVIA_CLIENTS_URL || '';

export const countryFlag = (country) => {
    if (!country) {
        return null;
    }
    const raw_code = typeof country === 'string' ? country : country.code;
    if (!raw_code) {
        return null;
    }
    const code = String(raw_code).toLowerCase();
    if (!baseUrl) {
        return null;
    }
    return `${baseUrl}/flags/${code}.svg`;
};